// Versioned key — bump the suffix to force a re-prompt when the policy changes.
export const CONSENT_STORAGE_KEY = 'onekyc.consent.v1';
export const CONSENT_EVENT = 'onekyc:consent-changed';

export type ConsentValue = 'accepted' | 'declined';

export function readConsent(): ConsentValue | null {
	if (typeof window === 'undefined') return null;
	try {
		const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
		return raw === 'accepted' || raw === 'declined' ? raw : null;
	} catch {
		return null;
	}
}

export function writeConsent(value: ConsentValue): void {
	if (typeof window === 'undefined') return;
	try {
		window.localStorage.setItem(CONSENT_STORAGE_KEY, value);
	} catch {
		// ignore — private mode / disabled storage
	}
	window.dispatchEvent(
		new CustomEvent<ConsentValue>(CONSENT_EVENT, { detail: value }),
	);
}
